var map = {
	"./img.png": 2040,
	"./img1.png": 1789,
	"./img10.png": 1790,
	"./img2.png": 1791,
	"./img3.png": 1792,
	"./img4.png": 1793,
	"./img5.png": 1794,
	"./img6.png": 1795,
	"./img7.png": 1796,
	"./img8.png": 1797,
	"./img9.png": 1798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2039;